import { LicensesComponent } from './pages/licenses/licenses.component';
import { licensesDataGuard } from './pages/licenses/licenses-data.guard';
import { CreateLicenseComponent } from './pages/create-license/create-license.component';
import { LicenseRenewalWorkflowsComponent } from './pages/license-renewals/license-renewals.component';
import { LicenseRenewalWorkflowWorkflowComponent } from './pages/license-extension-review-workflow/license-renewal-workflow.component';
import { LicenseStandaloneViewComponent } from './pages/license-view/license-standalone-view.component';
import { licenseRenewalWorkflowGuard } from './services/license-renewal-workflow.guard';

export const LICENSES_ROUTES = [
  {
    path: '',
    component: LicensesComponent,
    canActivate: [licensesDataGuard],
    data: { breadcrumb: 'Licenses' },
  },
  {
    path: 'new',
    component: CreateLicenseComponent,
    canActivate: [licenseRenewalWorkflowGuard],
    data: { breadcrumb: 'New License' },
  },
  {
    path: 'extension-reviews',
    component: LicenseRenewalWorkflowsComponent,
    canActivate: [licenseRenewalWorkflowGuard],
    data: { breadcrumb: 'License Renewals' },
  },
  {
    path: 'extension-reviews/:id',
    component: LicenseRenewalWorkflowWorkflowComponent,
    canActivate: [licenseRenewalWorkflowGuard],
    data: { breadcrumb: 'Review Workflow' },
  },
  {
    path: ':id',
    component: LicenseStandaloneViewComponent,
    data: { breadcrumb: 'License Details' },
  },
];
